import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";

export const SiteMiniMap = ({ lat, lng, color = "#9A3412" }) => {
  const icon = L.divIcon({
    className: "archive-pin",
    html: `<span style="background:${color};box-shadow:0 0 0 2px ${color},0 2px 6px rgba(0,0,0,.4)"></span>`,
    iconSize: [16, 16],
    iconAnchor: [8, 8],
  });
  return (
    <div className="h-64 border border-border overflow-hidden" data-testid="site-mini-map">
      <MapContainer center={[lat, lng]} zoom={5} scrollWheelZoom={false} style={{ height: "100%", width: "100%" }}>
        <TileLayer
          attribution="Tiles &copy; Esri"
          url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
          maxNativeZoom={16}
        />
        <TileLayer
          attribution="Labels &copy; Esri"
          url="https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}"
          maxNativeZoom={16}
          maxZoom={10}
        />
        <Marker position={[lat, lng]} icon={icon} />
      </MapContainer>
    </div>
  );
};
